import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { projDataBase } from "./firebase";

// Fetch all banners
export const fetchAllBanners = async () => {
  try {
    const snapshot = await getDocs(collection(projDataBase, "banners"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error while fetching Banners data.", err);
    throw err;
  }
};

// ✅ Delete Banner by ID
export const deleteBanner = async (id) => {
  await deleteDoc(doc(projDataBase, "banners", id));
};

// ✅ Update Banner by ID
export const updateBanner = async (id, updatedData) => {
  await updateDoc(doc(projDataBase, "banners", id), updatedData);
};

// ✅ Check the duplicate entry before inserting
export const checkIfDuplicateExists = async (collectionName, fieldsToCheck) => {
  try {
    const collectRef = collection(projDataBase, collectionName);

    const conditions = Object.entries(fieldsToCheck).map(([key, value]) => {
      return where(key, "==", value); // ✅ Important: return the where condition
    });

    const qry = query(collectRef, ...conditions);
    const qrySnapshot = await getDocs(qry);

    return !qrySnapshot.empty; // true for duplicate entry
  } catch (err) {
    console.error("Error while interacting with banners data.", err);
    throw err;
  }
};

// Fetch all recipes
export const fetchAllRecipes = async () => {
  try {
    const snapshot = await getDocs(collection(projDataBase, "recipes"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error while fetching Recipes data.", err);
    throw err;
  }
};

export const fetchRecipeById = async (id) => {
  try {
    const docRef = doc(projDataBase, "recipes", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      console.log("No such recipe found!");
      return null;
    }
  } catch (err) {
    console.error("Error while fetching Recipe data.", err);
    throw err;
  }
};

// Fetch all products
export const fetchAllProducts = async () => {
  try {
    const snapshot = await getDocs(collection(projDataBase, "products"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error while fetching Productss data.", err);
    throw err;
  }
};

// Fetch product by Id
export const fetchProductById = async (id) => {
  try {
    const docRef = doc(projDataBase, "products", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      console.log("No such recipe found!");
      return null;
    }
  } catch (err) {
    console.error("Error fetching product by ID: ", err);
    throw err;
  }
};

// Fetch all blogs
export const fetchAllBlogs = async () => {
  try {
    const snapshot = await getDocs(collection(projDataBase, "blogs"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error while fetching Blogs data.", err);
    throw err;
  }
};

// Fetch all videos
export const fetchAllVideos = async () => {
  try {
    const snapshot = await getDocs(collection(projDataBase, "videos"));
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error while fetching Video data.", err);
    throw err;
  }
};

//Add product
export const addProduct = async (product) => {
  try {
    const docRef = await addDoc(collection(projDataBase, "products"), product);
    return docRef;
  } catch (err) {
    console.error("Error while adding Product data.", err);
    throw err;
  }
};

//Add Blog
export const addBlog = async (blog) => {
  try {
    const docRef = await addDoc(collection(projDataBase, "blogs"), blog);
    return docRef;
  } catch (err) {
    console.error("Error while adding Blog data.", err);
    throw err;
  }
};

//Add Recipe
export const addRecipe = async (recipe) => {
  try {
    const docRef = await addDoc(collection(projDataBase, "recipes"), recipe);
    return docRef;
  } catch (err) {
    console.error("Error while adding Recipe data.", err);
    throw err;
  }
};

//Add Banner
export const addBanner = async (banner) => {
  try {
    const docRef = await addDoc(collection(projDataBase, "banners"), banner);
    return docRef;
  } catch (err) {
    console.error("Error while adding Banner data.", err);
    throw err;
  }
};

//Add Video
export const addVideo = async (video) => {
  try {
    const docRef = await addDoc(collection(projDataBase, "videos"), video);
    return docRef;
  } catch (err) {
    console.error("Error while adding Video data.", err);
    throw err;
  }
};

// Save Contact Us form message
export const saveContactMessage = async (messageData) => {
  try {
    await addDoc(collection(projDataBase, "contactMessages"), {
      ...messageData,
      createdAt: new Date().toISOString(),
    });
    return true;
  } catch (error) {
    console.error("❌ Error saving contact message:", error);
    return false;
  }
};
